import { processResponse } from '../utils'

function httpDeleteFactory(url, query = {}, options) {
  function httpDelete({ http, path, resolve }) {
    return processResponse(
      http.delete(resolve.value(url), resolve.value(query), options),
      path
    )
  }

  return httpDelete
}

export default httpDeleteFactory
